var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBenefitsBgShapeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 300,
    viewBox: "0 0 277 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2708_8533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 277,
    height: 300
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L277 0L277 299.425L0 299.425L0 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2708_8533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-117.125 109.259C-153.197 145.331 -153.197 203.821 -117.125 239.9C-93.5772 263.44 -58.3143 272.546 -26.3028 263.382C-7.32631 257.951 4.48387 246.126 19.5747 234.17C65.3063 197.93 128.09 163.375 187.367 187.403C204.783 194.468 187.119 160.043 184.392 154.925C130.328 53.4159 -3.28752 21.8128 -96.1871 91.1284C-103.594 96.6544 -110.593 102.72 -117.125 109.259Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.132 112.132C-145.564 146.564 -145.564 202.385 -111.132 236.817C-88.6637 259.293 -55.0046 267.975 -24.4512 259.234C-6.34229 254.051 4.93571 242.766 19.3339 231.357C62.9806 196.764 122.906 163.783 179.486 186.718C196.115 193.455 179.253 160.605 176.65 155.713C125.05 58.8331 -2.47845 28.666 -91.1424 94.825C-98.2139 100.103 -104.892 105.892 -111.132 112.125V112.132Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.147 115.004C-137.938 147.795 -137.938 200.956 -105.147 233.74C-83.7425 255.137 -51.6946 263.411 -22.5992 255.086C-5.35051 250.15 5.38073 239.404 19.0937 228.535C60.6553 195.597 117.723 164.191 171.606 186.025C187.44 192.441 171.379 161.158 168.901 156.5C119.765 64.2417 -1.68351 35.5182 -86.1118 98.5204C-92.8407 103.543 -99.2051 109.055 -105.147 114.996V115.004Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99.1548 117.876C-130.299 149.02 -130.299 199.52 -99.1548 230.664C-78.8296 250.989 -48.3855 258.848 -20.7482 250.938C-4.36706 246.25 5.832 236.044 18.8597 225.721C58.3363 194.431 112.547 164.599 163.724 185.347C178.764 191.442 163.513 161.727 161.158 157.302C114.478 69.6659 -0.875028 42.3785 -81.075 102.224C-87.4685 106.992 -93.5121 112.234 -99.1548 117.876Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.1614 120.749C-122.665 150.252 -122.665 198.084 -93.1614 227.587C-73.9078 246.834 -45.0676 254.284 -18.8884 246.79C-3.36747 242.35 6.2921 232.683 18.6272 222.9C56.0261 193.265 107.371 165.001 155.851 184.655C170.097 190.429 155.647 162.281 153.416 158.089C109.201 75.0755 -0.0649872 49.2316 -76.0366 105.92C-82.0948 110.44 -87.8176 115.405 -93.1614 120.749Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87.1764 123.621C-115.032 151.477 -115.032 196.647 -87.1764 224.503C-68.9945 242.685 -41.7582 249.713 -17.0442 242.641C-2.39086 238.449 6.72924 229.315 18.3863 220.085C53.7003 192.098 102.188 165.416 147.963 183.969C161.414 189.422 147.774 162.842 145.667 158.884C103.915 80.4989 0.72937 56.0912 -71.0066 109.616C-76.7294 113.881 -82.1315 118.569 -87.1764 123.613V123.621Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.1839 126.493C-107.4 152.709 -107.4 195.211 -81.1839 221.427C-64.0737 238.537 -38.4485 245.149 -15.1854 238.493C-1.39952 234.549 7.18838 225.954 18.1529 217.264C51.3818 190.924 97.0114 165.817 140.089 183.277C152.745 188.409 139.907 163.396 137.924 159.671C98.6372 85.9085 1.53844 62.9369 -65.9692 113.313C-71.3494 117.329 -76.438 121.74 -81.1839 126.486V126.493Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-75.1915 129.366C-99.7669 153.941 -99.7669 193.775 -75.1915 218.35C-59.153 234.389 -35.1316 240.586 -13.3338 234.345C-0.40821 230.649 7.64021 222.593 17.9122 214.45C49.0561 189.765 91.8279 166.225 132.201 182.592C144.07 187.403 132.034 163.958 130.175 160.466C93.3516 91.3253 2.34021 69.7972 -60.9391 117.016C-65.9839 120.778 -70.7517 124.911 -75.2061 129.366H-75.1915Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.2055 132.238C-92.1333 155.166 -92.1333 192.339 -69.2055 215.274C-54.2386 230.241 -31.8284 236.022 -11.4814 230.205C0.576672 226.749 8.08562 219.24 17.6796 211.636C46.7458 188.599 86.6525 166.641 124.328 181.914C135.402 186.405 124.175 164.527 122.44 161.268C88.0741 96.7494 3.15013 76.6647 -55.8862 120.72C-60.5957 124.234 -65.0428 128.09 -69.1982 132.246L-69.2055 132.238Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.2131 135.11C-84.5006 156.398 -84.5006 190.91 -63.2131 212.19C-49.3179 226.085 -28.5115 231.451 -9.62252 226.049C1.57529 222.841 8.54476 215.872 17.4461 208.815C44.4273 187.432 81.4763 167.042 116.455 181.221C126.734 185.384 116.309 165.08 114.698 162.055C82.7959 102.158 3.9519 83.51 -50.8561 124.408C-55.223 127.667 -59.3565 131.246 -63.2131 135.103V135.11Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBenefitsBgShapeRed);
export default __webpack_public_path__ + "static/media/products_benefits_bg_shape_red.6cf9f0cf58d20ce0eb1d156b85c8819d.svg";
export { ForwardRef as ReactComponent };